import { getSupplierRetailersAll, getProductsAll, getProducts } from './api/suppliers';
import { postPermissions } from './permissions';
import { alertSuccess, alertError } from './alert';
import { formatMany } from '../../utils/formatHelper';

import { setProductFiltersSetFilters, setProductFiltersOrder, setProductFiltersOrderField } from './productFilters';

import {
  PRODUCTS_DROPSHIP,
  PRODUCTS_DROPSHIP_ALL,
  PRODUCTS_DROPSHIP_COUNT,
  PRODUCTS_DROPSHIP_CHECK_ALL_ON_PAGE,
  PRODUCTS_DROPSHIP_UNCHECK_ALL,
  PRODUCTS_DROPSHIP_CHECK,
  PRODUCTS_DROPSHIP_UNCHECK,
  PRODUCTS_DROPSHIP_SEARCH,
  PRODUCTS_DROPSHIP_OFFSET,
  PRODUCTS_DROPSHIP_RETAILERS,
  PRODUCTS_DROPSHIP_LOADING_PRODUCTS,
  PRODUCTS_DROPSHIP_LOADING,
} from '../constants/productsDropshipTypes';

import { ORDER_TYPE_ECOMMERCE } from '../../constants/orderTypes';
import { variantServiceProductEndpointEnabled } from '../../constants/featureFlag';
import { getTotalCountHeader } from './api/utils';

const setProductsDropshipLoading = (products, value) => ({
  type: products ? PRODUCTS_DROPSHIP_LOADING_PRODUCTS : PRODUCTS_DROPSHIP_LOADING,
  payload: value,
});

const setProductsDropship = (data) => ({ type: PRODUCTS_DROPSHIP, payload: data });
const setProductsDropshipAll = (data) => ({ type: PRODUCTS_DROPSHIP_ALL, payload: data });
const setProductsDropshipCount = (count) => ({ type: PRODUCTS_DROPSHIP_COUNT, payload: count });

export const productsDropshipSubmit = (value) => async (dispatch, getState) => {
  if (value) {
    try {
      const state = getState();
      const { checked, retailers } = state.productsDropship;
      const { supplierId } = state.role;

      const variants = [];

      Object.keys(checked).forEach((model) => {
        checked[model].forEach((variantId) => {
          variants.push(variantId.id || variantId);
        });
      });

      const retailerIds = retailers.map((retailer) => retailer.id).filter((id) => value.retailers.includes(id));

      const data = [
        {
          retailer_ids: retailerIds,
          variant_ids: variants,
          ecommerce_approved: value.dropship,
        },
      ];

      const response = await postPermissions(supplierId, data);

      if (response && response.data.success) {
        if (value.dropship || value.replenishment) {
          dispatch(
            alertSuccess(
              `${Object.keys(checked).length} ${formatMany(Object.keys(checked).length, 'product')} approved to 
                            ${retailerIds.length} ${formatMany(retailerIds.length, 'retailer')}`,
            ),
          );
        } else {
          dispatch(
            alertSuccess(
              `${Object.keys(checked).length} ${formatMany(Object.keys(checked).length, 'product')} revoked from 
                            ${retailerIds.length} ${formatMany(retailerIds.length, 'retailer')}`,
            ),
          );
        }

        dispatch(productsDropshipUncheckAll);
      }
    } catch (error) {
      dispatch(alertError(error));
    }
  }
};

export const productsDropshipCheckAllOnPage = (ids) => ({ type: PRODUCTS_DROPSHIP_CHECK_ALL_ON_PAGE, payload: ids });

export const productsDropshipCheckAll = () => async (dispatch, getState) => {
  const state = getState();
  const { search } = state.productsDropship;
  const { supplierId } = state.role;
  const { currentFilters } = state.productFilters;

  try {
    const response = await getProductsAll(supplierId, currentFilters, search, ORDER_TYPE_ECOMMERCE);
    dispatch(setProductsDropshipAll(response.data));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const productsDropshipUncheckAll = { type: PRODUCTS_DROPSHIP_UNCHECK_ALL };

export const productsDropshipCheck = (id) => async (dispatch) => {
  dispatch({ type: PRODUCTS_DROPSHIP_CHECK, payload: id });
};

export const productsDropshipUncheck = (id) => async (dispatch) => {
  dispatch({ type: PRODUCTS_DROPSHIP_UNCHECK, payload: id });
};

export const getProductsDropship =
  (loadingProducts = true) =>
  async (dispatch, getState) => {
    const state = getState();
    const { supplierId } = state.role;
    const { perPage, offset, count, search } = state.productsDropship;
    const { currentFilters, order, orderField } = state.productFilters;
    const {
      flags: { [variantServiceProductEndpointEnabled]: variantServiceEnabled },
    } = state.featureFlags;
    dispatch(setProductsDropshipLoading(loadingProducts, true));

    try {
      const undefinedRetailerId = undefined;
      const response = await getProducts(
        supplierId,
        currentFilters,
        offset,
        perPage,
        search,
        order,
        orderField,
        ORDER_TYPE_ECOMMERCE,
        undefinedRetailerId,
        variantServiceEnabled,
      );

      const newCount = getTotalCountHeader(response);
      if (count !== newCount) {
        dispatch(setProductsDropshipCount(newCount));
      }

      dispatch(setProductsDropship(response.data));
    } catch (error) {
      dispatch(alertError(error));
    } finally {
      dispatch(setProductsDropshipLoading(loadingProducts, false));
    }
  };

export const setProductsDropshipSearch = (search) => (dispatch) => {
  dispatch({ type: PRODUCTS_DROPSHIP_SEARCH, payload: search });
  dispatch(setProductsDropshipOffset(0));
};

export const setProductsDropshipOffset = (offset) => (dispatch) => {
  dispatch({ type: PRODUCTS_DROPSHIP_OFFSET, payload: offset });
  dispatch(getProductsDropship());
};

export const setProductsDropshipOrderField = (orderField) => (dispatch, getState) => {
  dispatch(setProductFiltersOrderField(orderField));
  dispatch(getProductsDropship());
};

export const setProductsDropshipOrder = (order) => (dispatch) => {
  dispatch(setProductFiltersOrder(order));
  dispatch(getProductsDropship());
};

export const setProductsDropshipCurrentFilter = (filters) => (dispatch) => {
  dispatch(setProductFiltersSetFilters(filters));
  dispatch(setProductsDropshipOffset(0));
};

export const getProductsDropshipRetailers = () => async (dispatch, getState) => {
  try {
    const { supplierId } = getState().role;
    const response = await getSupplierRetailersAll(supplierId);

    dispatch({ type: PRODUCTS_DROPSHIP_RETAILERS, payload: response.data });
  } catch (error) {
    dispatch(alertError(error));
  }
};
